<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-set-surgery-price"
      ok-only
      centered
      size="lg"
      :title="$t('surgery.set-surgery-price')"
      @ok="submitSetSurgeryPrice()"
    >
      <b-card-text>
        <b-row>
          <b-col lg="6">
            <b-form-group
              :label="$t('reception.Surgery Price')"
              label-for="Amount"
            >
              <b-form-input
                id="Amount"
                v-model="surgeryPrice.price"
                type="number"
                :placeholder="$t('reception.Surgery Price')"
              />
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group
              :label="$t('reception.Surgery Discount')"
              label-for="Amount"
            >
              <b-form-input
                id="Amount"
                v-model="surgeryPrice.surgery_discount"
                type="number"
                :placeholder="$t('reception.Surgery Discount')"
              />
            </b-form-group>
          </b-col>
          <b-col lg="12">
            <b-row v-for="(item, i) in surgeryPrice.doctors" :key="item.id">
              <b-col lg="6" class="px-2 d-flex align-items-center">
                <h3>
                  {{ $t("surgery.Doctor") }} :
                  {{ surgeryPrice.doctors[i].name }}
                </h3>
              </b-col>
              <b-col lg="6">
                <b-form-group :label="$t('reception.Doctor Discount')">
                  <b-form-input
                    v-model="surgeryPrice.doctors[i].doctor_discount"
                    type="number"
                    :placeholder="$t('reception.Doctor Discount')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      :id="`modal-pay-doctor`"
      :title="$t('surgery.pay-doctor')"
      ok-only
      centered
      size="lg"
      :ok-title="$t('surgery.pay-doctor')"
      @ok="payDoctorPrice()"
    >
      <b-card-text>
        <b-row>
          <b-col lg="12">
            <b-row
              v-for="(item, i) in payDoctorDataPost.doctors"
              :key="item.id"
            >
              <b-col lg="6" class="px-2 d-flex align-items-center">
                <h3>
                  {{ $t("surgery.pay-doctor") }} :
                  {{ payDoctorDataPost.doctors[i].name }}
                </h3>
              </b-col>
              <b-col lg="6">
                <b-form-checkbox
                  :id="item.doctor_id"
                  v-model="payDoctorDataPost.doctors[i].isSelected"
                  name="checkbox-1"
                >
                  {{ $t("surgery.pay for this doctor") }}
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card :title="$t('accounting.surgery-accounting')">
      <!-- Search Patient Name -->
      <div>
        <b-row class="mt-4">
          <!-- <b-col cols="12" md="12">
            <h2>{{ $t("surgery.surgery-patient-history") }}</h2>
            <br />
          </b-col> -->
          <b-col md="3" cols="12">
            <b-form-group :label="$t('common.name')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="surgeryName"
                :placeholder="$t('common.name')"
              />
            </b-form-group>
          </b-col>
          <b-col md="3" cols="12">
            <AutoComplete
              :label="$t('surgery.surgery')"
              v-model="surgery_id"
              :serializer="(val) => val.id"
              param-query="search"
              endpoint="surgery"
              text-title="title"
            />
          </b-col>
          <b-col md="2" cols="12">
            <b-form-group :label="$t('common.date')" label-for="surgery_date">
              <datepicker
                id="surgery_date"
                v-model="surgery_date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>
          <!-- <b-col md="2" cols="12">
              <b-form-group :label="$t('common.price')" label-for="Price">
                <b-form-input
                  id="Price"
                  type="number"
                  v-model="surgeyPrice"
                  :placeholder="$t('common.price')"
                />
              </b-form-group>
            </b-col> -->
          <b-col
            md="2"
            cols="4"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getSurgeryList()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>

        <b-table
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- has_sub_surgery -->
          <template #cell(title)="data">
            <div class="text-nowrap">
              {{ data.item.patient_card.patient.name }}
            </div>
          </template>
          <template #cell(has_sub_surgery)="data">
            <div class="text-nowrap">
              <span
                style="font-weight: bold; color: green"
                v-if="data.item.sub_surgeries.length"
                >{{ $t("common.yes") }}</span
              >
              <span v-else style="font-weight: bold; color: red">
                {{ $t("common.no") }}</span
              >
            </div>
          </template>
          <template #cell(is_sub_surgery)="data">
            <div class="text-nowrap">
              <span
                style="font-weight: bold; color: green"
                v-if="data.item.parent_id"
                >{{ $t("common.yes") }}</span
              >
              <span v-else style="font-weight: bold; color: red">
                {{ $t("common.no") }}</span
              >
            </div>
          </template>
          <template #cell(money_collected)="data">
            <div class="text-nowrap">
              <span
                style="font-weight: bold; color: green"
                v-if="data.item.money_collected === 1"
                >{{ $t("common.yes") }}</span
              >
              <span v-else style="font-weight: bold; color: red">
                {{ $t("common.no") }}</span
              >
            </div>
          </template>
          <!-- money_collected -->
          <template #cell(type)="data">
            <div class="text-nowrap">
              {{ data.item.surgery.title }}
            </div>
          </template>
          <template #cell(doctors)="data">
            <div
              class="text-nowrap d-flex flex-warp"
              v-if="data.item.doctors.length"
            >
              <div v-for="doctor in data.item.doctors">{{ doctor.name }} -</div>
            </div>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->

              <!-- <b-button
                v-if="$store.state.app.permissions.includes('get-surgery')"
                @click="
                  $router.push({
                    name: 'patient-surgery-info',
                    params: { id: data.item.id },
                  })
                "
                pill
                size="sm"
                variant="outline-secondary"
                class="mb-75 mx-1"
              >
                {{ $t("surgery.preview-surgery") }}
              </b-button> -->
              <b-button
                v-if="$store.state.app.permissions.includes('get-invoice')"
                size="sm"
                pill
                variant="outline-secondary"
                class="mb-75 mx-1"
                @click="
                  $router.push({
                    name: 'acounting-invoices',
                    params: {
                      patientId: data.item.patient_card.patient_id,
                      patientCardId: data.item.patient_card.id,
                      isPatientAccounting: 'false',
                      isSurgeryAccounting: 'true',
                    },
                    query: {
                      patientCardId: data.item.patient_card
                        ? data.item.patient_card.id
                        : undefined,
                    },
                  })
                "
              >
                {{ $t("hospital.preview-invoices") }}
              </b-button>
            </div>
          </template>
          <template #cell(is_active)="data">
            <div>
              {{ data.item.patient_card ? "Active" : "not Active" }}
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getSurgeryList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormSelect,
  BLink,
  BFormCheckbox,
} from "bootstrap-vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import permissionChecker from "@/mixins/permissionChecker";
import vSelect from "vue-select";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import Datepicker from "vuejs-datepicker";

export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    BFormCheckbox,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormSelect,
    BLink,
    StatisticCardHorizontal,
    vSelect,
    AutoComplete,
    Datepicker,
  },
  data() {
    return {
      take: 10,
      loading: true,
      dataCount: 0,
      data: [],
      tableColumns: [
        { key: "title", sortable: true, label: this.$t("common.name") },
        // { key: "price", sortable: true, label: this.$t("common.price") },
        // {
        //   key: "total_discount",
        //   sortable: true,
        //   label: this.$t("surgery.total_discount"),
        // },
        // {
        //   key: "total_price_after_discount",
        //   sortable: true,
        //   label: this.$t("surgery.total_price_after_discount"),
        // },
        { key: "type", sortable: true, label: this.$t("common.type") },
        // {
        //   key: "procedure",
        //   sortable: true,
        //   label: this.$t("surgery.procedure"),
        // },
        {
          key: "doctors",
          sortable: true,
          label: this.$t("surgery.Doctor"),
        },
        {
          key: "surgery_date_time",
          sortable: true,
          label: this.$t("surgery.surgery_date_time"),
        },
        // {
        //   key: "has_sub_surgery",
        //   sortable: true,
        //   label: this.$t("surgery.has_sub_surgery"),
        // },
        // {
        //   key: "is_sub_surgery",
        //   sortable: true,
        //   label: this.$t("surgery.is_sub_surgery"),
        // },
        {
          key: "money_collected",
          sortable: true,
          label: this.$t("surgery.is_money_collected"),
        },
        {
          key: "is_active",
          label: this.$t("common.status"),
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("common.actions"),
        },
      ],
      params: {
        form: {},
        path: "",
      },
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      surgery_set_price_id: "",
      surgeryPrice: {
        price: 0,
        surgery_discount: 0,
        doctors: [
          {
            id: "",
            doctor_discount: "",
            name: "",
          },
        ],
      },
      payDoctorData: {},
      payDoctorDataPost: {
        id: "",
        doctors: { doctor_id: "", name: "", isSelected: false },
      },
      surgery_id: null,
    };
  },
  mounted() {
    this.getSurgeryList();
  },
  methods: {
    showModal(item) {
      this.$bvModal.show("modal-pay-doctor");
      this.payDoctorData = item;
      this.payDoctorDataPost.doctors = item.doctors.map((doctor) => {
        return { doctor_id: doctor.id, name: doctor.name, isSelected: false };
      });
    },
    show(item) {
      this.surgery_set_price_id = item.id;
      this.surgeryPrice.price = item.surgery.price;
      this.surgeryPrice.doctors = item.doctors.map((doctor) => {
        return { id: doctor.id, doctor_discount: 0, name: doctor.name };
      });
      this.$bvModal.show("modal-set-surgery-price");
    },
    formatDate(wantedDate) {
      const date = new Date(wantedDate);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    async submitSetSurgeryPrice() {
      this.surgeryPrice.doctors = this.surgeryPrice.doctors.map((doctor) => {
        return { id: doctor.id, doctor_discount: doctor.doctor_discount };
      });
      (this.params.form = this.surgeryPrice),
        (this.params.path = `/patient-surgery/prices/${this.surgery_set_price_id}`),
        this.$store
          .dispatch("put", this.params)
          .then((response) => {
            this.$bvModal.hide("modal-set-surgery-price");
            this.getSurgeryList();
          })
          .catch((error) => {
            if (error.response.status === 400) {
              Object.keys(error.response.data).forEach((item) => {
                this.errorForm[item] = error.response.data[item][0];
              });
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    async getSurgeryList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/patient-surgery?page=${this.page}&take=${this.take}&sort=-id&include=surgery,doctors`;

      if (this.surgeryName) {
        url += `&filter[patientCard.patient.name]=${this.surgeryName}`;
      }
      if (this.surgeyPrice) {
        url += `&filter[price]=${this.surgeyPrice}`;
      }
      if (this.surgery_date) {
        console.log(this.surgery_date);
        url += `&filter[created_at]=${this.formatDate(this.surgery_date)}`;
      }
      if (this.surgery_id) {
        url += `&filter[surgery_id]=${this.surgery_id}`;
      }
      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },
    payDoctorPrice() {
      const isSelectAll = this.payDoctorDataPost.doctors.find(
        (x) => x.isSelected === false
      );
      if (!isSelectAll) {
        (this.params.form = ""),
          (this.params.path = `/patient-surgery/${this.payDoctorData.id}/payDoctor`),
          this.$store
            .dispatch("put", this.params)
            .then((response) => {
              this.getSurgeryList();
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "pay doctor",
                  variant: "success",
                  text: "Doctor has been paid successfully",
                },
              });
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        this.payDoctorDataPost.doctors.forEach((item) => {
          if (item.isSelected === true) {
            const data = { doctor_id: item.doctor_id };
            (this.params.form = data),
              (this.params.path = `/patient-surgery/${this.payDoctorData.id}/payDoctor`),
              this.$store
                .dispatch("put", this.params)
                .then((response) => {
                  this.getSurgeryList();
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "pay doctor",
                      variant: "success",
                      text: "Doctor has been paid successfully",
                    },
                  });
                })
                .catch((error) => {
                  if (error.response.status === 400) {
                    for (let item in error.response.data) {
                      this.$toast({
                        component: ToastificationContent,
                        position: "top-right",
                        props: {
                          title: "validation error",
                          variant: "danger",
                          text: error.response.data[item][0],
                        },
                      });
                    }
                  }
                });
          }
        });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
